import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import ProfileInfoEdit from "../Modal/accountInfoEdit";
import { useTranslation } from "react-i18next";

const Edit = ({ userProfile, userInfo, userTerm, userModifyRequest, setModalToggle }) => {
	const { t } = useTranslation();
	const userIdImg = { id: userInfo.id, img: userInfo.img };

	const [emailReceiveTerm, setEmailReceiveTerm] = useState(false);

	useEffect(() => {
		setEmailReceiveTerm(userTerm[2].status);
	}, [userTerm]);

	const emailReceiveCheck = (e) => {
		!emailReceiveTerm ? setEmailReceiveTerm(true) : setEmailReceiveTerm(false);
	};

	const editForm = useForm({
		defaultValues: {
			UserProfile: { ...userProfile, ...userIdImg },
		},
	});

	const submit = (data) => {
		const dataMaker = (object, dataList) => {
			return dataList.reduce((acc, cur) => {
				// acc = {}
				// cur = dataList 의 값을 순차적으로 가져옴
				acc[cur] = object[cur];
				return acc;
			}, {});
		};
		const profileDataName = [
			"name", // 필수
			"phone",
			"introduction",
			"zipCode",
			"address",
			"addressDetail",
			"facebook",
			"twitter",
			"instagram",
			"linkedin",
			"youtube",
			"department",
			"position",
		];
		const requestData = {
			img: data.UserProfile.img,
			emailReceiveTerm: emailReceiveTerm,
			UserProfile: dataMaker(data.UserProfile, profileDataName),
		};

		userModifyRequest.singleCall(requestData);
	};

	return (
		<>
			<div className="modal-content">
				<ProfileInfoEdit
					useForm={editForm}
					emailReceiveCheck={emailReceiveCheck}
					emailReceiveTerm={emailReceiveTerm}
				/>
			</div>
			<div className="modal-footer">
				<button
					type="button"
					className="btn__solid"
					color="gray"
					onClick={() => setModalToggle(false)}
				>
					{t("common.commonWord.button.cancel")}
				</button>
				<button
					type="button"
					className="btn__solid"
					color="primary"
					onClick={editForm.handleSubmit(submit)}
				>
					{t("common.commonWord.button.save")}
				</button>
			</div>
		</>
	);
};

export default Edit;
